import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { abc, glue, download, numbers } from '../utils/icons';
import Action from './Action';
import { TinyTextWrapper, TinyTitle } from './CommonUiComponents';

const StyledSidenote = styled.div`
  max-width: 16.875rem;
  margin: 1rem 0;

  &:not(:last-child) {
    margin-bottom: 2rem;
  }
`;

const Icon = styled.i`
  display: block;
  margin-bottom: 0.5em;

  .svg-fill-color {
    fill: ${props => props.theme.tertiary};
  }

  .svg-stroke-color {
    stroke: ${props => props.theme.tertiary};
  }
`;

const Sidenote = ({
  title,
  children,
  action = null,
  actionLabel = null,
  sheet = false,
  factBox = false,
  link = false,
  num = false,
  icon = true
}) => (
  <StyledSidenote>
    {icon && title === 'Materiell' && <Icon>{glue}</Icon>}
    {icon && factBox && !num && <Icon>{abc}</Icon>}
    {icon && num && <Icon>{numbers}</Icon>}
    <TinyTitle>{title}</TinyTitle>
    <TinyTextWrapper dangerouslySetInnerHTML={{ __html: children }} />
    {action !== null && (
      <Action href={action} icon={!link ? download : null}>
        {actionLabel}
      </Action>
    )}
  </StyledSidenote>
);

Sidenote.propTypes = {
  title: PropTypes.string,
  action: PropTypes.string,
  actionLabel: PropTypes.string,
  sheet: PropTypes.bool,
  factBox: PropTypes.bool,
  link: PropTypes.bool,
  num: PropTypes.bool,
  icon: PropTypes.bool
};

export default Sidenote;



// WEBPACK FOOTER //
// ./src/components/Sidenote.js